import React, {
  useEffect,
  useContext,
  useState
} from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  makeStyles,
} from '@material-ui/core';

import { useHttpClient } from '../../../../hooks/http-hook';
import { AuthContext } from '../../../../shared/context/auth-context';
import LoadingSpinner from '../../../../shared/component/UIElements/LoadingSpinner';
import ErrorMessage from '../../../../shared/component/UIElements/ErrorMessage';

import Tabelas from '../../../../shared/component/UIElements/Tabelas';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  header: {
    border: '1px solid #ACACAC',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    '& .MuiCardHeader-title': {
      fontSize: '20px',
      fontWeight: 700,
      fontFamily: 'Roboto',
      color: '#3E3E3E'
    }
  },
  container: {
    borderLeft: '1px solid #ACACAC',
    borderRight: '1px solid #ACACAC',
    borderBottom: '1px solid #ACACAC',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    padding: '0px 0px 0px 0px',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  box: {
    flexGrow: 1
  },
  numero: {
    fontSize: '45px',
    fontWeight: 500,
    color: '#3E3E3E',
    textAlign: 'center'
  },
  descricao: {
    fontSize: '21px',
    fontWeight: 700,
    color: '#808080',
    textAlign: 'center',
    maxWidth: '166px',
    lineHeight: '21px'
  },
  borda: {
    borderRight: '1px solid #ACACAC'
  },
  acessos: {
    marginTop: '18px'
  },
  titulo: {
    fontSize: '33px',
    fontWeight: 500,
    color: '#3E3E3E',
    textAlign: 'left'
  },
  topo: {
    margin: '25px 0px'
  },
  altura: {
    height: '100%'
  }
}));

const Recentes = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [relatorios, setRelatorios] = useState([]);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  useEffect(() => {
    const fetchRelatorios = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/relatorios/recentes`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        if (responseData.sucesso) {
          setRelatorios(() => {
            const data = [...responseData.data.map((acervo) => ({
              id: acervo._id,
              nome: {
                conteudo: acervo.nome,
                tipo: 'avatar',
                avatar: acervo.destaque !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${acervo.destaque.caminho}` : '',
              },
              criacao: {
                conteudo: new Date(acervo.createdDate).toLocaleString(),
                tipo: 'data'
              },
              status: {
                conteudo: acervo.status,
                tipo: 'text'
              },
            }))];
            return data;
          });
          clearError();
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchRelatorios();
  }, [sendRequest, auth]);

  if (isLoading) {
    return (
      <>
        <LoadingSpinner asOverlay />
      </>
    );
  }

  return (
    <Card>
      <CardHeader
        title="Ultímos itens cadastrados"
        className={classes.header}
      />
      <CardContent
        className={classes.container}
      >
        <Tabelas
          data={relatorios}
          minWidth="auto"
          className={classes.altura}
          limite={3}
          rowsPerPageOptions={[]}
          estrutura={[
            { id: 'nome', tipo: 'avatar', nome: 'Item' },
            { id: 'data', tipo: 'data', nome: 'Data de Cadastro' },
            { id: 'status', tipo: 'texto', nome: 'Estado' },
          ]}
        />
        <ErrorMessage error={error} onClear={clearError} />
      </CardContent>
    </Card>
  );
};

export default Recentes;
